import React, { useState, useEffect, Fragment } from 'react';
import { Modal, message, Button } from 'antd';
import { emptyFun } from '@untils/common';
import AuthButton from '../auth-button';

const GeneralModal = props => {
  const {
    className,
    displayHooks,
    onConfirm,
    onCancel = emptyFun,
    title = '',
    btnText = '  ',
    showBtn = true,
    width,
    authCode,
    hasCancel = true,
    hasConfirm = true,
    maskClosable = true,
    cancelText = '取消',
    confirmText = '确定',
    onOpen,
  } = props;
  const [isInit, setIsInit] = useState(true);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    isInit ? setIsInit(false) : setVisible(!visible);
  }, [displayHooks]);

  useEffect(() => {
    if (visible) {
      onOpen?.();
    }
  }, [visible]);

  const handleShow = () => {
    setVisible(true);
  };
  const handleOk = async () => {
    if (!onConfirm) {
      setVisible(false);
      return;
    }
    setLoading(true);
    const { success = false, msg = '' } = (await onConfirm()) || {};

    setLoading(false);
    success && setVisible(false);
    success && msg && message.success(msg);
    !success && msg && message.error(msg);
  };

  const handleCancel = () => {
    onCancel();
    setVisible(false);
  };

  const getFooter = () => {
    if (!hasCancel && !hasConfirm) {
      return null;
    }

    return (
      <>
        {hasCancel && (
          <Button key="back" onClick={handleCancel}>
            {cancelText}
          </Button>
        )}

        {hasConfirm && (
          <Button key="submit" type="primary" loading={loading} onClick={handleOk}>
            {confirmText}
          </Button>
        )}
      </>
    );
  };

  return (
    <Fragment>
      {showBtn && (
        <AuthButton type="primary" onClick={handleShow} authCode={authCode}>
          {btnText}
        </AuthButton>
      )}
      <Modal
        className={className}
        title={title}
        visible={visible}
        destroyOnClose
        maskClosable={maskClosable}
        // onOk={handleOk}
        onCancel={handleCancel}
        width={width}
        footer={getFooter()}
      >
        {props.children}
      </Modal>
    </Fragment>
  );
};

export default GeneralModal;
